<template>
    <div class="image-card box--hovered-color-border">
        <div class="image-card__image">
            <img :src="getImageThemeUrl(theme)">
            <div class="mask image-mask box box--center box--space-inside">
                <button @click="() => onThemeClick(theme)"
                        class="button--wider-border button--uppercase button--xl button transparent-white--button">
                    Zobraziť v mape
                </button>
            </div>
        </div>

        <div class="image-card__content">
            <div class="box box--space-inside">
                <strong class="text--smaller-paragraph text--colored">
                    Slovensko:
                </strong>
                <div class="text--bigger-paragraph mt-2">
                    {{theme.name}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        theme: {
            type: Object,
            required: true
        },
        getImageThemeUrl: {
            type: Function,
            required: true
        },
        onThemeClick: {
            type: Function,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.image-card {
    border-radius: 0;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    //cursor: pointer;
    -webkit-transition: border 0.3s;
    transition: border 0.3s;
    position: relative;
    background-size: cover;
    margin-bottom: 2.4rem;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.2);
}

.image-card__image {
    height: 30rem;
    position: relative;
    overflow: hidden;
    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}


.image-card__content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    background-color: rgba(255, 255, 255, 0.8);
    height: 11rem;
}

.image-mask {
    background: linear-gradient(180deg, rgba(0,143,153,0.71) 0%, rgba(0,150,161,0.71) 5%, rgba(255,255,255,0) 48%);
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
}
</style>